module.exports = __webpack_public_path__ + "img/富奥.png";